/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Site_Url_PlaceholderInputs */

const en_site_url_placeholder = /** @type {(inputs: Site_Url_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`e.g. plane.so or https://competitor-shop.com`)
};

const id_site_url_placeholder = /** @type {(inputs: Site_Url_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`contoh: plane.so atau https://toko-saingan.id`)
};

/**
* | output |
* | --- |
* | "e.g. plane.so or https://competitor-shop.com" |
*
* @param {Site_Url_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const site_url_placeholder = /** @type {((inputs?: Site_Url_PlaceholderInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Site_Url_PlaceholderInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_site_url_placeholder(inputs)
	return en_site_url_placeholder(inputs)
});